import { useEffect } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import TrustRow from "@/components/landing/TrustRow";
import Services from "@/components/landing/Services";
import WhyUs from "@/components/landing/WhyUs";
import Process from "@/components/landing/Process";
import CaseStudies from "@/components/landing/CaseStudies";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import Team from "@/components/landing/Team";
import StrategicPartner from "@/components/landing/StrategicPartner";
import Contact from "@/components/landing/Contact";
import Footer from "@/components/landing/Footer";
import { ScrollToTop } from "@/components/landing/ScrollToTop";

const Index = () => {
  useEffect(() => {
    document.title = "Kayros — Deep-Tech & Dual-Use Fundraising Advisory | EU & UK";
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", "Investment-readiness, pitch materials, and 120+ EU/UK investor introductions for deep-tech and dual-use founders. Book a confidential call.");
    }
  }, []);
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main id="main-content">
        <Hero />
        <TrustRow />
        <Services />
        <WhyUs />
        <Process />
        <CaseStudies />
        <Pricing />
        <Team />
        <StrategicPartner />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
};

export default Index;
